import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3e50c938"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "compute-page__content-container" }
const _hoisted_2 = { class: "compute-page__close-label" }
const _hoisted_3 = { class: "compute-page__header" }
const _hoisted_4 = { class: "compute-page__title" }
const _hoisted_5 = { class: "compute-page__tag" }
const _hoisted_6 = {
  key: 0,
  class: "compute-page__subtitle"
}
const _hoisted_7 = { class: "compute-page__slot-container" }
const _hoisted_8 = { class: "compute-page__navigation" }

import { computed } from 'vue';
import { IonPage, IonContent, useIonRouter } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { RoutePath } from '@/enums/Router';
import BaseStepper from '@/components/BaseStepper.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import { Icons } from '@/enums/Icons';
import { useComputeWizardStore } from '@/store/computeWizard';

import useSizeStoreValidation from '@/composables/ComputeWizard/Validation/useSizeStoreValidation';
import useSurfaceStoreValidation from '@/composables/ComputeWizard/Validation/useSurfaceStoreValidation';
import useFrictionStoreValidation from '@/composables/ComputeWizard/Validation/useFrictionStoreValidation';
import useQualityStoreValidation from '@/composables/ComputeWizard/Validation/useQualityStoreValidation';
import useClampingStoreValidation from '@/composables/ComputeWizard/Validation/useClampingStoreValidation';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputePage',
  props: {
    currentStep: { default: 1 },
    title: {},
    subtitle: {},
    prevUrl: {},
    nextUrl: {},
    updateFinalResultOnClose: { type: Boolean, default: false }
  },
  emits: ["onPreStep", "onNextStep", "onClose"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const router = useIonRouter();
const computeWizardStore = useComputeWizardStore();
const sizeStoreValidation = useSizeStoreValidation();
const surfaceStoreValidation = useSurfaceStoreValidation();
const frictionStoreValidation = useFrictionStoreValidation();
const qualityStoreValidation = useQualityStoreValidation();
const clampingStoreValidation = useClampingStoreValidation();

const props = __props;

// type-based
const emit = __emit;

const isLastStep = computed(() => {
  return props.currentStep >= 5;
});

const nextButtonLabel = computed(() => {
  return isLastStep.value ? t('wizard.submit') : t('wizard.next');
});

const checkStepValidation = async (): Promise<boolean> => {
  const currentStore = [
    sizeStoreValidation,
    surfaceStoreValidation,
    frictionStoreValidation,
    qualityStoreValidation,
    clampingStoreValidation,
  ][props.currentStep - 1];

  return currentStore.validateTheStep();
};

const prevStep = async (): Promise<void> => {
  if (!(await checkStepValidation())) {
    return;
  }

  if (props.prevUrl) {
    emit('onPreStep');
    router.back();
  }
};

const nextStep = async (): Promise<void> => {
  if (!(await checkStepValidation())) {
    return;
  }

  if (props.nextUrl) {
    emit('onNextStep');
    router.push(props.nextUrl);
  }
};

const goBack = async (): Promise<void> => {
  if (!(await checkStepValidation())) {
    return;
  }

  if (computeWizardStore.isValid || props.updateFinalResultOnClose) {
    computeWizardStore.updateFinalResult();
  }

  emit('onClose');
  router.push(RoutePath.HOME);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "compute-page" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "compute-page__ion-content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(BaseButton, {
              class: "compute-page__close",
              color: "light",
              onClick: goBack
            }, {
              default: _withCtx(() => [
                _createVNode(BaseIcon, {
                  class: "compute-page__close-icon",
                  icon: _unref(Icons).Cross
                }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('wizard.close')), 1)
              ]),
              _: 1
            }),
            _createVNode(BaseStepper, {
              class: "compute-page__stepper",
              total: 5,
              current: _ctx.currentStep
            }, null, 8, ["current"]),
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentStep), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
              ]),
              (_ctx.subtitle)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.subtitle), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.currentStep > 1)
                ? (_openBlock(), _createBlock(BaseButton, {
                    key: 0,
                    rounded: "",
                    color: "medium",
                    class: "compute-page__navigator",
                    icon: _unref(Icons).BackArrow,
                    "icon-slot": "start",
                    onClick: prevStep
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('wizard.previous')), 1)
                    ]),
                    _: 1
                  }, 8, ["icon"]))
                : _createCommentVNode("", true),
              _createVNode(BaseButton, {
                rounded: "",
                class: "compute-page__navigator",
                icon: _unref(Icons).NextArrow,
                onClick: nextStep
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(nextButtonLabel.value), 1)
                ]),
                _: 1
              }, 8, ["icon"])
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})